// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31zqT","input":"styles_input__3LTT3"};